<template>
  <div class="wrapper-multiselect">
    <multiselect
      @search-change="onSeacrh"
      @open="onOpenDropdown"
      @input="onInput"
      v-model="selectedOption"
      :multiple="multiple"
      :options="options"
      :searchable="searchable"
      :internal-search="internalSearch"
      :label="label"
      :track-by="trackBy"
      :loading="loading"
      :placeholder="placeholder">
        <template slot="noResult">
          <span>No result</span>
        </template>
      </multiselect>
  </div>
</template>
<script>
import multiselect from 'vue-multiselect';
import { isEmpty, find } from 'lodash';

export default {
  name: 'base-multiselect',
  components: {
    multiselect,
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  props: {
    initSelect: {
      type: String,
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'name',
    },
    options: {
      type: Array,
      default: [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    trackBy: {
      type: String,
      default: 'id',
    },
    placeholder: {
      type: String,
      default: 'Select Option',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    internalSearch: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSeacrh(queryValue) {
      this.$emit('search-change', queryValue);
    },
    onOpenDropdown() {
      this.$emit('open');
    },
    onInput(value) {
      const { name } = this;
      if (!isEmpty(value)) {
        const pushValue = {
          value,
          name,
        };
        this.$emit('input-value', pushValue);
      } else {
        this.$emit('input-value', { name, value: null });
      }
    },
  },
  watch: {
    initSelect(id) {
      const selected = find(this.options, { id });
      this.selectedOption = selected;
    },
  },
};
</script>

<style lang="sass" scoped>
.wrapper-multiselect
  width: 100%
  height: 35px
  min-height: 35px
  max-height: 35px
</style>



// WEBPACK FOOTER //
// src/components/BaseMultiselect.vue